import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form';
import FieldError from './FieldError';
import PlaceSearchBox from '../common/googlemap/PlaceSearchBox';
import DisplayLocation from '../common/googlemap/DisplayLocation';

export default function AddressField({
    name,
    className,
    placeholder,
    label,
    info,
    customErrorMessage,
    registerOptions = {}
}) {
    const { register, errors, setValue, watch } = useFormContext();
    const location = watch("location");
    const address = watch("address");

    useEffect(() => {
        register({ name: 'address', type: 'custom' });
        register({ name: 'location', type: 'custom' });
    }, [register]);

    const handlePlaceChanged = places => {
        if (places.geometry.location) {
            setValue('location', { lat: places.geometry.location.lat(), lng: places.geometry.location.lng() });
            setValue('address', places.formatted_address);
        }
    };

    const handleBlur = e => {
        setValue('address', e.target.value);
    };

    const handleChange = e => {
        setValue('location', null);
    };

    const styles = {
        wrapper: {
            marginBottom: "1.5rem",
        },
        label: {
            display: "block",
            fontWeight: "bold",
            marginBottom: "0.5rem",
            color: "#26344a",
            fontSize: "1.8rem",
        },
        control: {
            marginBottom: "1rem",
        },
        help: {
            color: "#23d160",
            fontSize: "1.1rem",
            marginTop: "0.25rem",
        }
    };

    return (
        <div style={styles.wrapper} className={className}>
            <label style={styles.label}>
                {label}
                {registerOptions['required'] && <span style={{ color: "#ff3860", marginLeft: "0.25rem" }}>*</span>}
            </label>
            <div style={styles.control}>
                <PlaceSearchBox
                    onPlaceChanged={handlePlaceChanged}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={address}
                    placeholder={placeholder}
                />
            </div>
            {info && <p style={styles.help}>{info}</p>}
            <FieldError errors={errors[name]} customErrorMessage={customErrorMessage} />
            <DisplayLocation location={location} style={{ height: '32rem' }} />
        </div>
    )
}
